// <s-product-gallery> links the thumbnail buttons to the scroll-snap media track:
// clicking a thumbnail scrolls its slide into view, and scrolling the track marks
// the matching thumbnail as current.
class SProductGallery extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const track = this.querySelector('[data-gallery-track]');
    const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
    if (!track || thumbs.length === 0) return;

    const slides = [...track.children];
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setCurrent = (index) => {
      thumbs.forEach((thumb, i) => {
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener(
        'click',
        () => {
          const slide = slides[index];
          if (!slide) return;
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
          setCurrent(index);
        },
        { signal }
      );
    });

    let frame = 0;
    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const width = track.clientWidth || 1;
          const index = Math.round(Math.abs(track.scrollLeft) / width);
          setCurrent(Math.min(index, thumbs.length - 1));
        });
      },
      { signal, passive: true }
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-product-gallery')) {
  customElements.define('s-product-gallery', SProductGallery);
}
